import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChatWindowComponent } from '../../components/chat-window/chat-window.component';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  standalone: false,
})
export class SupportComponent extends BasePage {
  constructor(private dialog: MatDialog) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    //this.openChat();
  }

  public openChat() {
    //window.open("http://localhost:8082/queue.html", "_blank");

    let dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.height = '525px';
    dialogConfig.data = { message: 'Hello!' };
    dialogConfig.hasBackdrop = false;
    dialogConfig.panelClass = 'custom-dialog-container';

    // Modal
    this.dialog.open(ChatWindowComponent, dialogConfig);
  }
}
